// extracted by mini-css-extract-plugin
export default {"OperatorPage":"OrderPadPage_OperatorPage__+ZS+u","container":"OrderPadPage_container__7rXOV","form":"OrderPadPage_form__v8rGf"};